import {AfterViewInit, Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {MatPaginator} from '@angular/material/paginator';
import {MatSort} from '@angular/material/sort';
import {MatTableDataSource} from '@angular/material/table';
import {MesswertPaket} from '../../../../model/messwerte/messwert-paket';
import {SearchFilterService} from '../../../../service/search/search-filter.service';
import {MesswertTableColumn} from '../../../../model/component/messwert-table-filter';
import {WerteConverterUtil} from '../../../../util/werte-converter-util';

@Component({
  selector: 'app-messwert-tabelle',
  templateUrl: './messwert-tabelle.component.html',
  styleUrls: ['./messwert-tabelle.component.css']
})
export class MesswertTabelleComponent implements OnInit, AfterViewInit {

  @Input()
  set messwertPakete(messwertPakete: MesswertPaket[]) {
    this.dataSource.data = messwertPakete;
  }

  @Output()
  reloadData: EventEmitter<void> = new EventEmitter<void>();

  dataSource = new MatTableDataSource<MesswertPaket>();
  displayedColumns = ['name', 'bundesland', 'lufttemperatur', 'lufttemperaturBoden', 'windrichtung',
    'windgeschwindigkeit', 'feuchtigkeit', 'taupunkt', 'horizontaleSichtweite', 'niederschlagsmenge', 'wetterzustand', 'quelle'];

  date: Date = new Date();

  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;
  @ViewChild(MatSort, {static: true}) sort: MatSort;

  @ViewChild('table', {read: ElementRef}) tableRef: ElementRef;

  constructor(private searchFilterService: SearchFilterService, public werteConverter: WerteConverterUtil) {
  }

  ngOnInit(): void {
    this.dataSource.filterPredicate = this.getFilterPredicate();
    this.searchFilterService.onMesswerteSearchFilterUpdated.subscribe(filterValue => {
      this.dataSource.filter = filterValue;
    });
  }

  ngAfterViewInit(): void {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sortingDataAccessor = this.getSortingAccessor();
    this.dataSource.sort = this.sort;
    this.sort.sortChange.subscribe(() => this.paginator.pageIndex = 0);
  }


  updateColumnVisibility(column: MesswertTableColumn) {
    if (column.selected) {
      this.displayedColumns.push(column.name);
    } else {
      const index = this.displayedColumns.indexOf(column.name, 0);
      this.displayedColumns.splice(index, 1);
    }
  }

  private getFilterPredicate() {
    return (dataRow: MesswertPaket, filterValue: string) => {
      const ortStr = JSON.stringify(dataRow.ort.name).toLowerCase();
      const quelleStr = JSON.stringify(dataRow.ort.quelle).toLowerCase();
      const bundeslandStr = JSON.stringify(dataRow.ort.bundesLand).toLowerCase();
      const dataStr = ortStr.concat(quelleStr).concat(bundeslandStr);

      if (filterValue.includes(',')) {
        const filters: Array<string> = filterValue.split(',');
        let match = false;
        for (const f of filters) {
          if (ortStr.indexOf(f) !== -1 || quelleStr.indexOf(f) !== -1 || bundeslandStr.indexOf(f) !== -1) {
            match = true;
          }
        }
        return match;
      }
      return dataStr.indexOf(filterValue) !== -1;
    };
  }

  private getSortingAccessor() {
    return (element: MesswertPaket, property) => {
      switch (property) {
        case 'id':
          return element.ort.id;
        case 'quelle':
          return element.ort.quelle;
        case 'bundesland':
          return element.ort.bundesLand;
        case 'typ':
          return element.ort.typ;
        case 'name':
          return element.ort.name;
        case 'lufttemperatur':
          return element.messwerte.lufttemperatur?.messwert;
        case 'lufttemperaturBoden':
          return element.messwerte.lufttemperaturBoden?.messwert;
        case 'feuchtigkeit':
          return element.messwerte.relativeFeuchtigkeit?.messwert;
        case 'windgeschwindigkeit':
          return element.messwerte.mittlereWindgeschwindigkeit?.messwert;
        case 'windrichtung':
          return element.messwerte.mittlereWindrichtung?.messwert;
        case 'taupunkt':
          return element.messwerte.taupunttemperatur?.messwert;
        case 'horizontaleSichtweite':
          return element.messwerte.horizontaleSichtweite?.messwert;
        case 'wetterzustand':
          return element.messwerte.wetterzustand?.messwert;
        case 'luftdruck':
          return element.messwerte.luftdruck?.messwert;
        case 'niederschlagsart':
          return element.messwerte.niederschalgsTyp?.messwert;
        case 'niederschlagsmenge':
          return element.messwerte.niederschlagsMenge?.messwert;
        case 'maxwindboee':
          return element.messwerte.maxWindboee?.messwert;
        case 'sonnenscheindauer':
          return element.messwerte.sonnenscheindauer?.messwert;
      }
    };
  }

  scrollUp() {
    setTimeout(() => this.tableRef.nativeElement.scrollIntoView({behavior: 'smooth', block: 'start'}));
  }

}
